import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

export default function NavigationMobileMenuItem({ isActive, className = '', ...props }) {
    const menuItemClassNames = classNames(
      'block rounded-md px-3 py-2 text-base font-medium',
      {
        'bg-gray-950/50 text-white': isActive,
        'text-gray-300 hover:bg-white/5 hover:text-white': !isActive
      },
      className
    );
  return <Link key={props.id} to={props.to} className={menuItemClassNames} aria-current={isActive ? "page" : undefined}>{props.text}</Link>;
}
